import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Loader } from '../../Elements/Loader';
import { useScrollNavigationContext } from '../../hooks/useScrollNavigation';
import { Item } from './components';
import { LoaderWrapper, Wrapper } from './styled';
export const HorizontalNavigationGroup = memo(function HorizontalNavigationGroup({ isLoading, persistKey, }) {
    const { activeId, scrollToSection, sections } = useScrollNavigationContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const handleScrollToItem = useCallbackRef((id) => {
        if (persistKey) {
            setSearchParams((prev) => {
                prev.set(persistKey, id);
                return prev;
            });
        }
        scrollToSection(id);
    });
    useEffect(() => {
        if (!persistKey)
            return;
        const activeTabId = searchParams.get(persistKey);
        if (activeTabId && sections.some((section) => section.id === activeTabId)) {
            scrollToSection(activeTabId, { behavior: 'instant' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sections]);
    return (_jsxs(Wrapper, { children: [isLoading && (_jsx(LoaderWrapper, { children: _jsx(Loader, { height: 44 }) })), !isLoading &&
                sections.map(({ id, title, dataTestId }) => (_jsx(Item, { id: id, title: title, active: id === activeId, setActiveId: handleScrollToItem, dataTestId: dataTestId }, id)))] }));
});
